export default __webpack_public_path__ + "static/media/dartSFX.1c78fbda.mp3";